module.exports = "/assets/8b492b393f1aac0c76f975930e84fd14.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/YV.png
// module id = 3161
// module chunks = 0